/*!

=========================================================
* Now UI Dashboard React - v1.5.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";
import { NavLink } from "react-router-dom";
import { Nav } from "reactstrap";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { Link } from "react-router-dom";
import dashRoutes from "routes";
import { PropaneSharp } from "@mui/icons-material";
import { SCHOOL_INFO } from "utils/constants";
var ps;

function Sidebar() {

  const sidebar = React.useRef();
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return window.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(sidebar.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
    };
  });

  return (
    <div className="sidebar" style={{ backgroundColor: `${SCHOOL_INFO?.color} !important` }}>
      <div className="logo">
        <Link
          to="/home"
          style={{ color: "offwhite", fontSize: "12pt" }}
          className="simple-text logo-normal fw-bolder"
        >
          <img src={SCHOOL_INFO?.logo} alt="react-logo" height="50" width="50" />

          <span className="ms-2">STUDENT PORTAL</span>
        </Link>
      </div>
      <div className="sidebar-wrapper" ref={sidebar}>
        <Nav>
          {dashRoutes.map((prop, key) => {
            // if (prop.redirect) return null;
            return (
              <li
                className={
                  activeRoute(prop.path) +
                  (prop.pro ? " active active-pro" : "")
                }
                key={key}
              >
                <NavLink
                  to={prop.path}
                  className="nav-link"
                  activeClassName="active"
                >
                  <i
                    id="sidelinkicon"
                    className={
                      prop.icon === "fas fa-heart"
                        ? prop.icon
                        : "now-ui-icons " + prop.icon
                    }
                    style={{ color: prop.style }}
                  />
                  <p style={{ fontSize: "9pt" }} className="fw-bold">
                    {prop.name}
                  </p>
                </NavLink>
              </li>
            );
          })}
        </Nav>
      </div>
    </div>
  );
}

export default Sidebar;
